module.exports = __webpack_public_path__ + "img/store-demandware.78762173.svg";